import telegramAnalytics from '@telegram-apps/analytics';
import QRCode from 'qrcode';

const analyticsToken = import.meta.env.VITE_TELEGRAM_ANALYTICS_TOKEN;
const analyticsAppName = import.meta.env.VITE_TELEGRAM_ANALYTICS_APP_NAME;

if (analyticsToken && analyticsAppName) {
    try {
        telegramAnalytics.init({
            token: analyticsToken,
            appName: analyticsAppName,
        });
    } catch (error) {
        console.warn('Failed to initialize Telegram Analytics:', error);
    }
}

function initTelegramWebApp() {
    const webApp = window.Telegram.WebApp;
    webApp.expand();
    webApp.ready();
    return webApp;
}

let tg;
if (window.Telegram && window.Telegram.WebApp) {
    tg = initTelegramWebApp();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            if (window.Telegram && window.Telegram.WebApp) {
                tg = initTelegramWebApp();
                initApp();
            }
        }, 120);
    });
}

const CHAR_SETS = {
    uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lowercase: 'abcdefghijklmnopqrstuvwxyz',
    numbers: '0123456789',
    special: '!@#$%^&*()_+-=[]{}|;:,.<>?'
};

const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 30000;
const APP_TITLE = 'Payment Request & Receipt Generator';
const USDT_MAINNET_CONTRACT = '0xdAC17F958D2ee523a2206206994597C13D831ec7';
const RICHADS_INTERSTITIAL_ID = String(import.meta.env.VITE_RICHADS_INTERSTITIAL_ID || '').trim();
const RICHADS_SDK_URL = String(import.meta.env.VITE_RICHADS_SDK_URL || '').trim();

function readStarPrice(envValue, fallback) {
    const parsed = Number.parseInt(envValue || String(fallback), 10);
    if (!Number.isFinite(parsed) || parsed < 1) {
        return fallback;
    }
    return parsed;
}

const PRO_PRICE_STARS = readStarPrice(import.meta.env.VITE_TELEGRAM_PRO_PRICE, 100);

const MSG_PRO_SUCCESS = 'No Ads mode is now active.';
const MSG_PAYMENT_PROCESSING = 'Payment processing... your No Ads mode will activate shortly.';

const state = {
    mode: 'string',
    generatedResult: null,
    richAdsLoaded: false,
    isGenerating: false,
    isShowingInterstitial: false,
    isPro: false,
    isSyncingPro: false,
    pollInterval: null,
    pollStartTime: null,
    paymentNetwork: 'bitcoin',
    paymentUri: '',
    paymentQrDataUrl: '',
    paymentCardDataUrl: '',
    receiptImageDataUrl: '',
    receiptTxHash: '',
    receiptChain: 'bitcoin',
    receiptExplorerUrl: '',
    receiptFeeCurrency: 'BTC',
    receiptFetchedData: null
};

const elements = {
    modeLabel: document.getElementById('mode-label'),
    proLabel: document.getElementById('pro-label'),
    buyProBtn: document.getElementById('buy-pro-btn'),

    payNetworkBtc: document.getElementById('pay-network-btc'),
    payNetworkEth: document.getElementById('pay-network-eth'),
    payNetworkUsdt: document.getElementById('pay-network-usdt'),
    payNetworkSol: document.getElementById('pay-network-sol'),
    btcPaymentFields: document.getElementById('btc-payment-fields'),
    ethPaymentFields: document.getElementById('eth-payment-fields'),
    usdtPaymentFields: document.getElementById('usdt-payment-fields'),
    solPaymentFields: document.getElementById('sol-payment-fields'),
    btcAddress: document.getElementById('btc-address'),
    btcAmount: document.getElementById('btc-amount'),
    btcLabel: document.getElementById('btc-label'),
    btcMessage: document.getElementById('btc-message'),
    ethRequestType: document.getElementById('eth-request-type'),
    ethRecipient: document.getElementById('eth-recipient'),
    ethAmount: document.getElementById('eth-amount'),
    ethChainId: document.getElementById('eth-chain-id'),
    ethTokenFields: document.getElementById('eth-token-fields'),
    ethTokenAddress: document.getElementById('eth-token-address'),
    ethTokenDecimals: document.getElementById('eth-token-decimals'),
    usdtRecipient: document.getElementById('usdt-recipient'),
    usdtAmount: document.getElementById('usdt-amount'),
    usdtChainId: document.getElementById('usdt-chain-id'),
    usdtTokenAddress: document.getElementById('usdt-token-address'),
    solAddress: document.getElementById('sol-address'),
    solAmount: document.getElementById('sol-amount'),
    solReference: document.getElementById('sol-reference'),
    solLabel: document.getElementById('sol-label'),
    solMessage: document.getElementById('sol-message'),
    paymentCardTitle: document.getElementById('payment-card-title'),
    paymentCardSubtitle: document.getElementById('payment-card-subtitle'),
    paymentAmountLabel: document.getElementById('payment-amount-label'),
    paymentTargetLabel: document.getElementById('payment-target-label'),
    paymentPayeeName: document.getElementById('payment-payee-name'),
    paymentDescription: document.getElementById('payment-description'),
    generatePaymentUriBtn: document.getElementById('generate-payment-uri-btn'),
    paymentOutput: document.getElementById('payment-output'),
    paymentUriText: document.getElementById('payment-uri-text'),
    paymentQrImage: document.getElementById('payment-qr-image'),
    copyPaymentUriBtn: document.getElementById('copy-payment-uri-btn'),
    downloadPaymentQrBtn: document.getElementById('download-payment-qr-btn'),
    sendPaymentQrBtn: document.getElementById('send-payment-qr-btn'),
    paymentFeedback: document.getElementById('payment-feedback'),

    receiptChain: document.getElementById('receipt-chain'),
    receiptCurrency: document.getElementById('receipt-currency'),
    receiptTxHash: document.getElementById('receipt-tx-hash'),
    fetchTxBtn: document.getElementById('fetch-tx-btn'),
    receiptDetails: document.getElementById('receipt-details'),
    receiptSender: document.getElementById('receipt-sender'),
    receiptReceiver: document.getElementById('receipt-receiver'),
    receiptAmount: document.getElementById('receipt-amount'),
    receiptFee: document.getElementById('receipt-fee'),
    receiptConfirmations: document.getElementById('receipt-confirmations'),
    receiptTimestamp: document.getElementById('receipt-timestamp'),
    receiptExplorerUrl: document.getElementById('receipt-explorer-url'),
    receiptTitle: document.getElementById('receipt-title'),
    receiptSubtitle: document.getElementById('receipt-subtitle'),
    receiptSenderLabel: document.getElementById('receipt-sender-label'),
    receiptReceiverLabel: document.getElementById('receipt-receiver-label'),
    receiptAmountLabel: document.getElementById('receipt-amount-label'),
    receiptFeeLabel: document.getElementById('receipt-fee-label'),
    receiptDescription: document.getElementById('receipt-description'),
    generateReceiptBtn: document.getElementById('generate-receipt-btn'),
    receiptOutput: document.getElementById('receipt-output'),
    receiptImagePreview: document.getElementById('receipt-image-preview'),
    downloadReceiptBtn: document.getElementById('download-receipt-btn'),
    sendReceiptBtn: document.getElementById('send-receipt-btn'),
    receiptFeedback: document.getElementById('receipt-feedback'),

    modeString: document.getElementById('mode-string'),
    modeNumber: document.getElementById('mode-number'),
    stringOptions: document.getElementById('string-options'),
    optUppercase: document.getElementById('opt-uppercase'),
    optLowercase: document.getElementById('opt-lowercase'),
    optNumbers: document.getElementById('opt-numbers'),
    optSpecial: document.getElementById('opt-special'),
    stringLength: document.getElementById('string-length'),
    lengthSlider: document.getElementById('length-slider'),
    lengthDecrease: document.getElementById('length-decrease'),
    lengthIncrease: document.getElementById('length-increase'),
    numberOptions: document.getElementById('number-options'),
    minNumber: document.getElementById('min-number'),
    maxNumber: document.getElementById('max-number'),
    generateBtn: document.getElementById('generate-btn'),
    resultSection: document.getElementById('result-section'),
    resultText: document.getElementById('result-text'),
    copyBtn: document.getElementById('copy-btn'),
    resetBtn: document.getElementById('reset-btn'),
    copyFeedback: document.getElementById('copy-feedback')
};

function showAlert(message) {
    if (tg?.showAlert) {
        tg.showAlert(message);
        return;
    }
    window.alert(message);
}

function getUserId() {
    return tg?.initDataUnsafe?.user?.id || null;
}

function getChatId() {
    return tg?.initDataUnsafe?.user?.id || null;
}

function formatStars(price) {
    return price === 1 ? '1 Star' : `${price} Stars`;
}

function configureMonetizationButtons() {
    if (elements.buyProBtn) {
        const html = `No Ads Mode <span class="credit-cost">(${formatStars(PRO_PRICE_STARS)})</span>`;
        elements.buyProBtn.dataset.defaultLabel = html;
        elements.buyProBtn.innerHTML = html;
    }
}

function restoreDefaultButtonHtml(button) {
    if (!button) return;
    const defaultLabel = button.dataset.defaultLabel;
    if (defaultLabel) {
        button.innerHTML = defaultLabel;
    }
}

function setFeedback(element, message, isError = false) {
    if (!element) return;
    element.textContent = message;
    element.style.color = isError ? 'var(--danger)' : 'var(--success)';
}

async function copyTextWithFallback(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (_) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();

        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (_) {
            copied = false;
        }

        document.body.removeChild(textArea);
        return copied;
    }
}

async function syncUserStatus() {
    const userId = getUserId();
    if (!userId) {
        state.isPro = localStorage.getItem('stringgen_isPro') === 'true';
        updateMonetizationDisplay();
        return;
    }

    try {
        const response = await fetch(`/api/get-user-status?userId=${userId}`);
        const data = await response.json();

        if (!data.success) {
            throw new Error(data.message || 'Failed to sync user status');
        }

        state.isPro = data.isPro || false;
        localStorage.setItem('stringgen_isPro', state.isPro.toString());
        updateMonetizationDisplay();
    } catch (error) {
        console.error('Error syncing user status:', error);
        state.isPro = localStorage.getItem('stringgen_isPro') === 'true';
        updateMonetizationDisplay();
    }
}

async function pollStatusOnce() {
    const userId = getUserId();
    if (!userId) return false;

    try {
        const response = await fetch(`/api/get-user-status?userId=${userId}`);
        const data = await response.json();
        if (!data.success) return false;

        const previousIsPro = state.isPro;

        state.isPro = data.isPro || false;

        const hasUpdated = state.isPro !== previousIsPro;
        if (hasUpdated) {
            localStorage.setItem('stringgen_isPro', state.isPro.toString());
            updateMonetizationDisplay();
            if (!previousIsPro && state.isPro) {
                showAlert(MSG_PRO_SUCCESS);
            }
            return true;
        }
    } catch (error) {
        console.error('Error polling user status:', error);
    }

    return false;
}

function stopProPolling() {
    if (state.pollInterval) {
        clearInterval(state.pollInterval);
        state.pollInterval = null;
    }

    state.isSyncingPro = false;
    state.pollStartTime = null;
    updateMonetizationDisplay();
}

function startProPolling() {
    stopProPolling();
    state.isSyncingPro = true;
    state.pollStartTime = Date.now();
    updateMonetizationDisplay();

    state.pollInterval = setInterval(async () => {
        const elapsed = Date.now() - state.pollStartTime;
        if (elapsed > POLL_TIMEOUT_MS) {
            stopProPolling();
            showAlert('Status sync is taking longer than expected. Please check back in a moment.');
            return;
        }

        const updated = await pollStatusOnce();
        if (updated) {
            stopProPolling();
        }
    }, POLL_INTERVAL_MS);

    pollStatusOnce().then((updated) => {
        if (updated) stopProPolling();
    });
}

function updateMonetizationDisplay() {
    if (elements.modeLabel) {
        if (state.isSyncingPro) {
            elements.modeLabel.textContent = 'Activating No Ads...';
        } else if (state.isPro) {
            elements.modeLabel.textContent = 'No ads active';
        } else {
            elements.modeLabel.textContent = 'Interstitial ads after each generation';
        }
    }

    if (elements.proLabel) {
        elements.proLabel.style.display = state.isPro ? 'inline-block' : 'none';
    }

    if (elements.buyProBtn) {
        elements.buyProBtn.style.display = state.isPro ? 'none' : 'inline-flex';
    }
}

function toPromise(result) {
    if (result && typeof result.then === 'function') {
        return result;
    }
    return Promise.resolve(result);
}

function findRichAdsInterstitialRunner() {
    if (typeof window.showRichAdsInterstitial === 'function') {
        return () => window.showRichAdsInterstitial({
            placementId: RICHADS_INTERSTITIAL_ID,
            type: 'interstitial_video'
        });
    }

    const telegramAdsController = window.TelegramAdsController;
    if (telegramAdsController) {
        return () => {
            const attempts = [];

            if (typeof telegramAdsController.triggerInterstitialVideo === 'function') {
                attempts.push(() => telegramAdsController.triggerInterstitialVideo(false));
                attempts.push(() => telegramAdsController.triggerInterstitialVideo());
            }

            if (typeof telegramAdsController.showInterstitialVideo === 'function') {
                attempts.push(() => telegramAdsController.showInterstitialVideo());
            }

            if (typeof telegramAdsController.showInterstitial === 'function') {
                attempts.push(() => telegramAdsController.showInterstitial('interstitial_video'));
                attempts.push(() => telegramAdsController.showInterstitial({ type: 'interstitial_video' }));
            }

            if (typeof telegramAdsController.showAd === 'function') {
                attempts.push(() => telegramAdsController.showAd('interstitial_video'));
                attempts.push(() => telegramAdsController.showAd({ type: 'interstitial_video' }));
            }

            if (typeof telegramAdsController.show === 'function') {
                attempts.push(() => telegramAdsController.show('interstitial_video'));
                attempts.push(() => telegramAdsController.show({ type: 'interstitial_video' }));
            }

            let lastError = null;
            for (const attempt of attempts) {
                try {
                    return toPromise(attempt());
                } catch (error) {
                    lastError = error;
                }
            }

            if (lastError) {
                throw lastError;
            }

            throw new Error('TelegramAdsController is present but does not expose an interstitial video method.');
        };
    }

    const sdkObjects = [window.RichAds, window.richAds, window.richads].filter(Boolean);
    const baseOptions = RICHADS_INTERSTITIAL_ID
        ? { placementId: RICHADS_INTERSTITIAL_ID, type: 'interstitial_video' }
        : { type: 'interstitial_video' };

    for (const sdk of sdkObjects) {
        if (typeof sdk.showInterstitial === 'function') {
            return () => sdk.showInterstitial(baseOptions);
        }

        if (typeof sdk.init === 'function') {
            return () => {
                const controller = sdk.init(baseOptions);

                if (controller && typeof controller.show === 'function') {
                    return controller.show();
                }
                if (controller && typeof controller.showInterstitial === 'function') {
                    return controller.showInterstitial();
                }
                return Promise.reject(new Error('RichAds init succeeded but no interstitial show method is available.'));
            };
        }
    }

    return null;
}

function loadRichAdsSdkIfConfigured() {
    if (!RICHADS_SDK_URL) {
        return Promise.resolve();
    }

    if (state.richAdsLoaded) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = RICHADS_SDK_URL;
        script.onload = () => {
            state.richAdsLoaded = true;
            resolve();
        };
        script.onerror = () => reject(new Error('Failed to load RichAds SDK.'));
        document.head.appendChild(script);
    });
}

async function showRichAdsInterstitial() {
    if (state.isPro || state.isShowingInterstitial) {
        return;
    }

    state.isShowingInterstitial = true;
    try {
        await loadRichAdsSdkIfConfigured();
        const runInterstitial = findRichAdsInterstitialRunner();
        if (!runInterstitial) {
            throw new Error('RichAds bridge is missing. Ensure tg-ob.js is loaded and initialized, or provide window.showRichAdsInterstitial.');
        }
        await toPromise(runInterstitial());
    } catch (error) {
        console.error('Failed to show RichAds interstitial:', error);
    } finally {
        state.isShowingInterstitial = false;
    }
}

function generateRandomString(length, options) {
    let charset = '';
    if (options.uppercase) charset += CHAR_SETS.uppercase;
    if (options.lowercase) charset += CHAR_SETS.lowercase;
    if (options.numbers) charset += CHAR_SETS.numbers;
    if (options.special) charset += CHAR_SETS.special;

    if (!charset) {
        throw new Error('Please select at least one character type.');
    }

    if (!window.crypto || !window.crypto.getRandomValues) {
        throw new Error('Secure random generation is not available in this browser.');
    }

    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);
    let output = '';

    for (let i = 0; i < length; i += 1) {
        output += charset[randomValues[i] % charset.length];
    }

    return output;
}

function generateRandomNumber(min, max) {
    if (min > max) {
        throw new Error('Minimum must be less than or equal to maximum.');
    }

    if (!window.crypto || !window.crypto.getRandomValues) {
        throw new Error('Secure random generation is not available in this browser.');
    }

    const range = max - min + 1;
    const randomValue = new Uint32Array(1);
    crypto.getRandomValues(randomValue);
    return min + (randomValue[0] % range);
}

function switchMode(mode) {
    state.mode = mode;
    elements.modeString.classList.toggle('active', mode === 'string');
    elements.modeNumber.classList.toggle('active', mode === 'number');
    elements.stringOptions.style.display = mode === 'string' ? 'block' : 'none';
    elements.numberOptions.style.display = mode === 'number' ? 'block' : 'none';
    elements.resultSection.style.display = 'none';
    state.generatedResult = null;
}

function validateCheckboxes(event) {
    const hasSelection =
        elements.optUppercase.checked ||
        elements.optLowercase.checked ||
        elements.optNumbers.checked ||
        elements.optSpecial.checked;

    if (!hasSelection && state.mode === 'string') {
        event.target.checked = true;
        showAlert('Please keep at least one option selected.');
    }
}

function syncLengthFromSlider() {
    elements.stringLength.value = elements.lengthSlider.value;
}

function syncLengthFromInput() {
    let value = parseInt(elements.stringLength.value, 10);
    if (Number.isNaN(value) || value < 1) value = 1;
    if (value > 128) value = 128;
    elements.stringLength.value = value;
    elements.lengthSlider.value = value;
}

function adjustLength(delta) {
    let value = parseInt(elements.stringLength.value, 10) + delta;
    if (value < 1) value = 1;
    if (value > 128) value = 128;
    elements.stringLength.value = value;
    elements.lengthSlider.value = value;
}

async function handleGenerate() {
    if (state.isGenerating) return;

    state.isGenerating = true;
    elements.generateBtn.disabled = true;
    elements.generateBtn.classList.add('loading');
    let shouldShowInterstitial = false;

    try {
        let result;
        if (state.mode === 'string') {
            const length = parseInt(elements.stringLength.value, 10);
            const options = {
                uppercase: elements.optUppercase.checked,
                lowercase: elements.optLowercase.checked,
                numbers: elements.optNumbers.checked,
                special: elements.optSpecial.checked
            };
            result = generateRandomString(length, options);
        } else {
            const min = parseInt(elements.minNumber.value, 10);
            const max = parseInt(elements.maxNumber.value, 10);
            if (Number.isNaN(min) || Number.isNaN(max)) {
                throw new Error('Please enter valid numbers for minimum and maximum.');
            }
            result = generateRandomNumber(min, max).toString();
        }

        state.generatedResult = result;
        elements.resultText.textContent = result;
        elements.resultSection.style.display = 'block';
        setFeedback(elements.copyFeedback, '', false);
        shouldShowInterstitial = true;
    } catch (error) {
        console.error('Error generating value:', error);
        showAlert(error.message || 'Failed to generate value.');
    } finally {
        state.isGenerating = false;
        elements.generateBtn.classList.remove('loading');
        elements.generateBtn.disabled = false;
        if (shouldShowInterstitial) {
            await showRichAdsInterstitial();
        }
    }
}

async function handleCopyLegacyResult() {
    if (!state.generatedResult) {
        showAlert('Nothing to copy.');
        return;
    }
    const ok = await copyTextWithFallback(state.generatedResult);
    setFeedback(elements.copyFeedback, ok ? 'Copied to clipboard' : 'Failed to copy', !ok);
    if (ok) {
        setTimeout(() => setFeedback(elements.copyFeedback, '', false), 1800);
    }
}

function handleResetLegacy() {
    state.generatedResult = null;
    elements.resultSection.style.display = 'none';
    elements.resultText.textContent = '';
    setFeedback(elements.copyFeedback, '', false);

    elements.optUppercase.checked = true;
    elements.optLowercase.checked = true;
    elements.optNumbers.checked = true;
    elements.optSpecial.checked = false;
    elements.stringLength.value = 16;
    elements.lengthSlider.value = 16;
    elements.minNumber.value = 0;
    elements.maxNumber.value = 100;
    updateMonetizationDisplay();
}

function normalizeBitcoinAmount(rawAmount) {
    const trimmed = rawAmount.trim();
    if (!trimmed) return '';
    if (!/^\d+(\.\d+)?$/.test(trimmed)) {
        throw new Error('Bitcoin amount must be a valid number.');
    }
    const [integerPart, fractionPart = ''] = trimmed.split('.');
    if (fractionPart.length > 8) {
        throw new Error('Bitcoin amount supports up to 8 decimal places.');
    }
    return `${integerPart}.${fractionPart}`.replace(/\.0+$/, '').replace(/\.$/, '');
}

function validateBitcoinAddress(address) {
    const trimmed = address.trim();
    const legacyOrSegwit = /^(bc1[ac-hj-np-z02-9]{25,87}|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;
    if (!legacyOrSegwit.test(trimmed)) {
        throw new Error('Enter a valid Bitcoin address.');
    }
    return trimmed;
}

function normalizeEthAddress(address, fieldName = 'Ethereum address') {
    const trimmed = address.trim();
    if (!/^0x[a-fA-F0-9]{40}$/.test(trimmed)) {
        throw new Error(`${fieldName} is invalid.`);
    }
    return trimmed;
}

function normalizeSolanaAddress(address) {
    const trimmed = address.trim();
    if (!/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(trimmed)) {
        throw new Error('Enter a valid Solana address.');
    }
    return trimmed;
}

function decimalToUnits(value, decimals, fieldName) {
    const trimmed = value.trim();
    if (!/^\d+(\.\d+)?$/.test(trimmed)) {
        throw new Error(`${fieldName} must be a valid number.`);
    }

    const [whole, fractional = ''] = trimmed.split('.');
    if (fractional.length > decimals) {
        throw new Error(`${fieldName} supports up to ${decimals} decimal places.`);
    }

    const merged = `${whole}${fractional.padEnd(decimals, '0')}`.replace(/^0+/, '') || '0';
    return merged;
}

function normalizeSolAmount(rawAmount) {
    const trimmed = rawAmount.trim();
    if (!trimmed) return '';
    if (!/^\d+(\.\d+)?$/.test(trimmed)) {
        throw new Error('SOL amount must be a valid number.');
    }
    const [integerPart, fractionPart = ''] = trimmed.split('.');
    if (fractionPart.length > 9) {
        throw new Error('SOL amount supports up to 9 decimal places.');
    }
    return `${integerPart}.${fractionPart}`.replace(/\.0+$/, '').replace(/\.$/, '');
}

function switchPaymentNetwork(network) {
    state.paymentNetwork = network;
    elements.payNetworkBtc.classList.toggle('active', network === 'bitcoin');
    elements.payNetworkEth.classList.toggle('active', network === 'ethereum');
    elements.payNetworkUsdt.classList.toggle('active', network === 'usdt');
    elements.payNetworkSol.classList.toggle('active', network === 'solana');
    elements.btcPaymentFields.style.display = network === 'bitcoin' ? 'grid' : 'none';
    elements.ethPaymentFields.style.display = network === 'ethereum' ? 'grid' : 'none';
    elements.usdtPaymentFields.style.display = network === 'usdt' ? 'grid' : 'none';
    elements.solPaymentFields.style.display = network === 'solana' ? 'grid' : 'none';
}

function toggleEthTokenFields() {
    const isTokenTransfer = elements.ethRequestType.value === 'erc20';
    elements.ethTokenFields.style.display = isTokenTransfer ? 'grid' : 'none';
}

function buildBitcoinUri() {
    const address = validateBitcoinAddress(elements.btcAddress.value);
    const amount = normalizeBitcoinAmount(elements.btcAmount.value || '');
    const label = elements.btcLabel.value.trim();
    const message = elements.btcMessage.value.trim();

    const params = new URLSearchParams();
    if (amount) params.set('amount', amount);
    if (label) params.set('label', label);
    if (message) params.set('message', message);

    const query = params.toString();
    const uri = query ? `bitcoin:${address}?${query}` : `bitcoin:${address}`;

    return {
        uri,
        networkLabel: 'Bitcoin BIP-21',
        target: address,
        amountLabel: amount ? `${amount} BTC` : 'Flexible amount'
    };
}

function buildEthereumUri() {
    const requestType = elements.ethRequestType.value;
    const recipient = normalizeEthAddress(elements.ethRecipient.value, 'Recipient address');
    const chainId = Math.max(1, parseInt(elements.ethChainId.value, 10) || 1);
    const amount = elements.ethAmount.value.trim();

    if (requestType === 'erc20') {
        const tokenAddress = normalizeEthAddress(elements.ethTokenAddress.value, 'Token contract');
        const decimals = Math.max(0, Math.min(36, parseInt(elements.ethTokenDecimals.value, 10) || 0));
        if (!amount) throw new Error('Amount is required for ERC-20 transfers.');

        const units = decimalToUnits(amount, decimals, 'Token amount');
        const params = new URLSearchParams();
        params.set('address', recipient);
        params.set('uint256', units);

        return {
            uri: `ethereum:${tokenAddress}@${chainId}/transfer?${params.toString()}`,
            networkLabel: 'Ethereum EIP-681 (ERC-20)',
            target: recipient,
            amountLabel: amount
        };
    }

    const base = `ethereum:${recipient}@${chainId}`;
    if (!amount) {
        return {
            uri: base,
            networkLabel: 'Ethereum EIP-681',
            target: recipient,
            amountLabel: 'Flexible amount'
        };
    }

    const wei = decimalToUnits(amount, 18, 'ETH amount');
    return {
        uri: `${base}?value=${wei}`,
        networkLabel: 'Ethereum EIP-681',
        target: recipient,
        amountLabel: `${amount} ETH`
    };
}

function buildUsdtUri() {
    const recipient = normalizeEthAddress(elements.usdtRecipient.value, 'Recipient address');
    const amount = elements.usdtAmount.value.trim();
    const tokenAddress = normalizeEthAddress(elements.usdtTokenAddress.value || USDT_MAINNET_CONTRACT, 'USDT token contract');
    const chainId = Math.max(1, parseInt(elements.usdtChainId.value, 10) || 1);

    if (!amount) {
        throw new Error('Amount is required for USDT transfers.');
    }

    const units = decimalToUnits(amount, 6, 'USDT amount');
    const params = new URLSearchParams();
    params.set('address', recipient);
    params.set('uint256', units);

    return {
        uri: `ethereum:${tokenAddress}@${chainId}/transfer?${params.toString()}`,
        networkLabel: 'USDT EIP-681 (ERC-20)',
        target: recipient,
        amountLabel: `${amount} USDT`
    };
}

function buildSolanaUri() {
    const recipient = normalizeSolanaAddress(elements.solAddress.value);
    const amount = normalizeSolAmount(elements.solAmount.value || '');
    const label = elements.solLabel.value.trim();
    const message = elements.solMessage.value.trim();
    const reference = elements.solReference.value.trim();

    const params = new URLSearchParams();
    if (amount) params.set('amount', amount);
    if (label) params.set('label', label);
    if (message) params.set('message', message);
    if (reference) params.set('reference', reference);

    const query = params.toString();
    return {
        uri: query ? `solana:${recipient}?${query}` : `solana:${recipient}`,
        networkLabel: 'Solana Pay',
        target: recipient,
        amountLabel: amount ? `${amount} SOL` : 'Flexible amount'
    };
}

async function generateQrDataUrl(content) {
    if (!QRCode?.toDataURL) {
        throw new Error('QR library failed to load.');
    }
    return QRCode.toDataURL(content, {
        width: 500,
        margin: 1,
        errorCorrectionLevel: 'M',
        color: {
            dark: '#0f2433',
            light: '#ffffff'
        }
    });
}

function normalizeCustomText(value, maxLength = 80) {
    const trimmed = String(value || '').replace(/\s+/g, ' ').trim();
    if (!trimmed) return '';
    return trimmed.length > maxLength ? trimmed.slice(0, maxLength).trim() : trimmed;
}

function readCustomInput(element, fallback = '', maxLength = 80) {
    if (!element) return fallback;
    const value = normalizeCustomText(element.value, maxLength);
    return value || fallback;
}

function splitTextByWidth(ctx, text, maxWidth) {
    const lines = [];
    let current = '';

    for (const char of text) {
        const next = `${current}${char}`;
        if (ctx.measureText(next).width > maxWidth && current) {
            lines.push(current);
            current = char;
        } else {
            current = next;
        }
    }

    if (current) {
        lines.push(current);
    }

    return lines;
}

function wrapCanvasText(ctx, text, maxWidth) {
    const raw = String(text || '').trim();
    if (!raw) return [];

    const lines = [];
    const paragraphs = raw.split(/\r?\n/);

    paragraphs.forEach((paragraph) => {
        const words = paragraph.split(/\s+/).filter(Boolean);
        if (!words.length) {
            lines.push('');
            return;
        }

        let current = '';
        words.forEach((word) => {
            const candidate = current ? `${current} ${word}` : word;
            if (ctx.measureText(candidate).width <= maxWidth) {
                current = candidate;
                return;
            }

            if (current) {
                lines.push(current);
                current = '';
            }

            if (ctx.measureText(word).width <= maxWidth) {
                current = word;
                return;
            }

            const chunks = splitTextByWidth(ctx, word, maxWidth);
            if (chunks.length > 1) {
                lines.push(...chunks.slice(0, -1));
            }
            current = chunks[chunks.length - 1] || '';
        });

        if (current) {
            lines.push(current);
        }
    });

    return lines;
}

function clampCanvasLines(ctx, lines, maxWidth, maxLines) {
    if (lines.length <= maxLines) return lines;
    const output = lines.slice(0, maxLines);
    let last = output[maxLines - 1] || '';
    const suffix = '...';
    while (last && ctx.measureText(`${last}${suffix}`).width > maxWidth) {
        last = last.slice(0, -1);
    }
    output[maxLines - 1] = `${last}${suffix}`;
    return output;
}

function getPaymentCardDisplayOptions() {
    return {
        title: readCustomInput(elements.paymentCardTitle, 'Payment Request', 48),
        subtitle: normalizeCustomText(elements.paymentCardSubtitle?.value, 80),
        amountLabelTitle: readCustomInput(elements.paymentAmountLabel, 'Amount', 22),
        targetLabelTitle: readCustomInput(elements.paymentTargetLabel, 'To', 22),
        payeeName: normalizeCustomText(elements.paymentPayeeName?.value, 60),
        description: normalizeCustomText(elements.paymentDescription?.value, 110)
    };
}

function getReceiptDisplayOptions() {
    return {
        title: readCustomInput(elements.receiptTitle, 'On-chain Receipt', 48),
        subtitle: normalizeCustomText(elements.receiptSubtitle?.value, 90),
        senderLabel: readCustomInput(elements.receiptSenderLabel, 'From', 24),
        receiverLabel: readCustomInput(elements.receiptReceiverLabel, 'To', 24),
        amountLabel: readCustomInput(elements.receiptAmountLabel, 'Amount', 24),
        feeLabel: readCustomInput(elements.receiptFeeLabel, 'Network Fee', 24),
        description: normalizeCustomText(elements.receiptDescription?.value, 130)
    };
}

async function createPaymentCardImage({ uri, networkLabel, target, amountLabel }, qrDataUrl, displayOptions) {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 1600;
    const ctx = canvas.getContext('2d');

    const options = displayOptions || {};
    const cardTitle = options.title || 'Payment Request';
    const cardSubtitle = options.subtitle || networkLabel;
    const amountLabelTitle = options.amountLabelTitle || 'Amount';
    const targetLabelTitle = options.targetLabelTitle || 'To';
    const payeeName = options.payeeName || '';
    const description = options.description || '';

    ctx.fillStyle = '#f2f8fc';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    gradient.addColorStop(0, '#0b7a75');
    gradient.addColorStop(1, '#194563');
    ctx.fillStyle = gradient;
    ctx.fillRect(56, 56, canvas.width - 112, canvas.height - 112);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(96, 96, canvas.width - 192, canvas.height - 192);

    ctx.fillStyle = '#0f2433';
    ctx.font = '700 56px Space Grotesk';
    const titleLine = clampCanvasLines(ctx, wrapCanvasText(ctx, cardTitle, 900), 900, 1)[0] || cardTitle;
    ctx.fillText(titleLine, 140, 190);

    ctx.font = '500 32px Space Grotesk';
    ctx.fillStyle = '#45606f';
    const subtitleLine = clampCanvasLines(ctx, wrapCanvasText(ctx, cardSubtitle, 900), 900, 1)[0] || cardSubtitle;
    ctx.fillText(subtitleLine, 140, 238);

    ctx.font = '600 30px Space Grotesk';
    ctx.fillStyle = '#0f2433';
    ctx.fillText(`${amountLabelTitle}: ${amountLabel}`, 140, 308);

    ctx.font = '500 24px JetBrains Mono';
    ctx.fillStyle = '#234256';
    const targetLines = clampCanvasLines(ctx, wrapCanvasText(ctx, `${targetLabelTitle}: ${target}`, 900), 900, 2);
    targetLines.forEach((line, index) => {
        ctx.fillText(line, 140, 354 + (index * 34));
    });

    if (payeeName) {
        ctx.font = '600 24px Space Grotesk';
        ctx.fillStyle = '#0f2433';
        ctx.fillText(`Name: ${payeeName}`, 140, 428);
    }

    if (description) {
        ctx.font = '500 20px Space Grotesk';
        ctx.fillStyle = '#4c6372';
        const descriptionLines = clampCanvasLines(ctx, wrapCanvasText(ctx, description, 900), 900, 2);
        descriptionLines.forEach((line, index) => {
            ctx.fillText(line, 140, 462 + (index * 27));
        });
    }

    const qrImage = new Image();
    await new Promise((resolve, reject) => {
        qrImage.onload = resolve;
        qrImage.onerror = reject;
        qrImage.src = qrDataUrl;
    });
    ctx.drawImage(qrImage, 230, 500, 740, 740);

    ctx.fillStyle = '#0f2433';
    ctx.font = '500 20px JetBrains Mono';
    const uriLines = clampCanvasLines(ctx, wrapCanvasText(ctx, uri, 900), 900, 3);
    uriLines.forEach((line, index) => {
        ctx.fillText(line, 140, 1280 + (index * 28));
    });

    ctx.fillStyle = '#5b6874';
    ctx.font = '500 24px Space Grotesk';
    ctx.fillText(`Generated by ${APP_TITLE}`, 140, 1490);

    return canvas.toDataURL('image/png');
}

async function handleGeneratePaymentUri() {
    elements.generatePaymentUriBtn.classList.add('loading');
    elements.generatePaymentUriBtn.disabled = true;
    let shouldShowInterstitial = false;

    try {
        let payload;
        if (state.paymentNetwork === 'bitcoin') {
            payload = buildBitcoinUri();
        } else if (state.paymentNetwork === 'ethereum') {
            payload = buildEthereumUri();
        } else if (state.paymentNetwork === 'usdt') {
            payload = buildUsdtUri();
        } else {
            payload = buildSolanaUri();
        }
        const displayOptions = getPaymentCardDisplayOptions();
        const qrDataUrl = await generateQrDataUrl(payload.uri);
        const cardDataUrl = await createPaymentCardImage(payload, qrDataUrl, displayOptions);

        state.paymentUri = payload.uri;
        state.paymentQrDataUrl = qrDataUrl;
        state.paymentCardDataUrl = cardDataUrl;

        elements.paymentUriText.textContent = payload.uri;
        elements.paymentQrImage.src = qrDataUrl;
        elements.paymentOutput.style.display = 'block';
        setFeedback(elements.paymentFeedback, 'URI and QR generated.');
        shouldShowInterstitial = true;
    } catch (error) {
        console.error('Failed to generate payment URI:', error);
        showAlert(error.message || 'Failed to generate payment request.');
        setFeedback(elements.paymentFeedback, error.message || 'Failed to generate request.', true);
    } finally {
        elements.generatePaymentUriBtn.classList.remove('loading');
        elements.generatePaymentUriBtn.disabled = false;
        if (shouldShowInterstitial) {
            await showRichAdsInterstitial();
        }
    }
}

async function handleCopyPaymentUri() {
    if (!state.paymentUri) {
        showAlert('Generate a payment URI first.');
        return;
    }

    const ok = await copyTextWithFallback(state.paymentUri);
    setFeedback(elements.paymentFeedback, ok ? 'URI copied.' : 'Copy failed.', !ok);
}

function downloadDataUrl(dataUrl, filename) {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

async function sendImageToChat(dataUrl, filename, options = {}) {
    const chatId = getChatId();
    if (!chatId) {
        throw new Error('Open the app from a Telegram chat to send images directly.');
    }

    const caption = normalizeCustomText(options.caption || '', 900);
    const message = normalizeCustomText(options.message || '', 3500);

    const response = await fetch('/api/send-processed', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            chatId,
            filename,
            imageBase64: dataUrl,
            caption,
            message
        })
    });

    const payload = await response.json();
    if (!response.ok || !payload.success) {
        throw new Error(payload.message || 'Failed to send image to chat.');
    }
}

async function handleDownloadPaymentImage() {
    if (!state.paymentCardDataUrl) {
        showAlert('Generate a payment URI first.');
        return;
    }
    downloadDataUrl(state.paymentCardDataUrl, `payment-request-${Date.now()}.png`);
    setFeedback(elements.paymentFeedback, 'Image downloaded.');
}

async function handleSendPaymentToChat() {
    if (!state.paymentCardDataUrl) {
        showAlert('Generate a payment URI first.');
        return;
    }

    elements.sendPaymentQrBtn.classList.add('loading');
    elements.sendPaymentQrBtn.disabled = true;

    try {
        await sendImageToChat(
            state.paymentCardDataUrl,
            `payment-request-${Date.now()}.png`,
            {
                message: state.paymentUri
            }
        );
        setFeedback(elements.paymentFeedback, 'Sent to chat with full URI message.');
    } catch (error) {
        console.error('Failed to send payment image:', error);
        setFeedback(elements.paymentFeedback, error.message || 'Failed to send image.', true);
        showAlert(error.message || 'Failed to send image.');
    } finally {
        elements.sendPaymentQrBtn.classList.remove('loading');
        elements.sendPaymentQrBtn.disabled = false;
    }
}

function setReceiptDefaultsForChain(chain) {
    const defaults = {
        bitcoin: { currency: 'BTC', feeCurrency: 'BTC' },
        ethereum: { currency: 'ETH', feeCurrency: 'ETH' },
        usdt: { currency: 'USDT', feeCurrency: 'ETH' },
        solana: { currency: 'SOL', feeCurrency: 'SOL' }
    };

    const preset = defaults[chain] || defaults.ethereum;
    elements.receiptCurrency.value = preset.currency;
    state.receiptFeeCurrency = preset.feeCurrency;
    state.receiptChain = chain;
    state.receiptTxHash = '';
    state.receiptExplorerUrl = '';
    state.receiptFetchedData = null;

    elements.receiptSender.value = '';
    elements.receiptTxHash.value = '';
    elements.receiptReceiver.value = '';
    elements.receiptAmount.value = '';
    elements.receiptFee.value = '';
    elements.receiptConfirmations.value = '0';
    elements.receiptTimestamp.value = '';

    if (elements.receiptExplorerUrl) {
        elements.receiptExplorerUrl.value = '';
    }

    elements.receiptImagePreview.src = '';
    elements.receiptOutput.style.display = 'none';
    elements.receiptDetails.style.display = 'none';
    setFeedback(elements.receiptFeedback, '');
}

function formatIsoToFriendly(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
}

function shortHash(value, start = 8, end = 6) {
    if (!value || value.length <= start + end) return value || '';
    return `${value.slice(0, start)}...${value.slice(-end)}`;
}

function getChainDisplayName(chain) {
    const labels = {
        bitcoin: 'Bitcoin',
        ethereum: 'Ethereum',
        usdt: 'Ethereum (USDT)',
        solana: 'Solana'
    };
    return labels[chain] || chain;
}

async function fetchTransactionDetails() {
    const chain = elements.receiptChain.value;
    const txHash = elements.receiptTxHash.value.trim();

    if (!txHash) {
        showAlert('Enter a transaction hash first.');
        return;
    }

    elements.fetchTxBtn.classList.add('loading');
    elements.fetchTxBtn.disabled = true;

    try {
        const response = await fetch(`/api/get-transaction?chain=${encodeURIComponent(chain)}&txHash=${encodeURIComponent(txHash)}`);
        const data = await response.json();

        if (!response.ok || !data.success) {
            throw new Error(data.message || 'Unable to fetch transaction details.');
        }

        const tx = data.transaction;
        const normalizedCurrency = tx.currency || (chain === 'bitcoin' ? 'BTC' : chain === 'solana' ? 'SOL' : chain === 'usdt' ? 'USDT' : 'ETH');
        const fetchedData = {
            chain: tx.chain || chain,
            txHash: tx.txHash || txHash,
            sender: tx.sender || '',
            receiver: tx.receiver || '',
            amount: tx.amount || '',
            fee: tx.fee || '',
            confirmations: tx.confirmations ?? 0,
            timestamp: formatIsoToFriendly(tx.timestamp) || formatIsoToFriendly(new Date().toISOString()),
            currency: normalizedCurrency,
            feeCurrency: tx.feeCurrency || normalizedCurrency,
            explorerUrl: tx.explorerUrl || ''
        };

        state.receiptTxHash = fetchedData.txHash;
        state.receiptChain = fetchedData.chain;
        state.receiptExplorerUrl = fetchedData.explorerUrl;
        state.receiptFeeCurrency = fetchedData.feeCurrency;
        state.receiptFetchedData = fetchedData;

        elements.receiptSender.value = fetchedData.sender;
        elements.receiptReceiver.value = fetchedData.receiver;
        elements.receiptAmount.value = fetchedData.amount;
        elements.receiptFee.value = fetchedData.fee;
        elements.receiptConfirmations.value = String(fetchedData.confirmations);
        elements.receiptTimestamp.value = fetchedData.timestamp;
        elements.receiptCurrency.value = fetchedData.currency;
        if (elements.receiptExplorerUrl) {
            elements.receiptExplorerUrl.value = fetchedData.explorerUrl;
        }

        state.receiptImageDataUrl = '';
        elements.receiptOutput.style.display = 'none';
        elements.receiptDetails.style.display = 'grid';
        setFeedback(elements.receiptFeedback, fetchedData.explorerUrl
            ? 'Transaction loaded and locked. You can customize labels before generating.'
            : 'Transaction loaded and locked. Add custom labels, then generate.');
    } catch (error) {
        console.error('Fetch transaction failed:', error);
        setFeedback(elements.receiptFeedback, error.message || 'Failed to fetch transaction.', true);
        showAlert(error.message || 'Failed to fetch transaction.');
    } finally {
        elements.fetchTxBtn.classList.remove('loading');
        elements.fetchTxBtn.disabled = false;
    }
}

function collectReceiptData() {
    const fetchedData = state.receiptFetchedData;
    if (!fetchedData) {
        throw new Error('Fetch on-chain details first. Manual receipt edits are disabled.');
    }

    const currentInputTxHash = elements.receiptTxHash.value.trim();
    if (currentInputTxHash && fetchedData.txHash && currentInputTxHash.toLowerCase() !== fetchedData.txHash.toLowerCase()) {
        throw new Error('Transaction hash changed. Fetch on-chain details again before generating.');
    }

    if (!fetchedData.sender || !fetchedData.receiver || !fetchedData.amount || !fetchedData.fee) {
        throw new Error('Fetched transaction is missing required fields for a receipt.');
    }

    return {
        chain: fetchedData.chain,
        txHash: fetchedData.txHash,
        sender: fetchedData.sender,
        receiver: fetchedData.receiver,
        amount: fetchedData.amount,
        fee: fetchedData.fee,
        confirmations: String(fetchedData.confirmations ?? 0),
        timestamp: fetchedData.timestamp,
        currency: fetchedData.currency,
        feeCurrency: fetchedData.feeCurrency || fetchedData.currency,
        explorerUrl: fetchedData.explorerUrl || '',
        display: getReceiptDisplayOptions()
    };
}

async function createReceiptImage(data) {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 1860;
    const ctx = canvas.getContext('2d');

    const display = data.display || {};
    const title = display.title || 'On-chain Receipt';
    const subtitle = display.subtitle || `${getChainDisplayName(data.chain)} transaction receipt`;
    const senderLabel = display.senderLabel || 'From';
    const receiverLabel = display.receiverLabel || 'To';
    const amountLabel = display.amountLabel || 'Amount';
    const feeLabel = display.feeLabel || 'Fee';
    const description = display.description || '';

    ctx.fillStyle = '#f6f8fb';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const outerGradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    outerGradient.addColorStop(0, '#13324a');
    outerGradient.addColorStop(1, '#0b7a75');
    ctx.fillStyle = outerGradient;
    ctx.fillRect(60, 60, canvas.width - 120, canvas.height - 120);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(96, 96, canvas.width - 192, canvas.height - 192);

    ctx.fillStyle = '#0f2433';
    ctx.font = '700 54px Space Grotesk';
    const titleLine = clampCanvasLines(ctx, wrapCanvasText(ctx, title, 900), 900, 1)[0] || title;
    ctx.fillText(titleLine, 150, 185);

    ctx.font = '600 26px Space Grotesk';
    ctx.fillStyle = '#466372';
    const subtitleText = subtitle || `${getChainDisplayName(data.chain)} • ${data.currency}`;
    const subtitleLines = clampCanvasLines(ctx, wrapCanvasText(ctx, subtitleText, 900), 900, 2);
    subtitleLines.forEach((line, index) => {
        ctx.fillText(line, 150, 232 + (index * 30));
    });

    if (description) {
        ctx.font = '500 20px Space Grotesk';
        ctx.fillStyle = '#506976';
        const descriptionLines = clampCanvasLines(ctx, wrapCanvasText(ctx, description, 900), 900, 2);
        descriptionLines.forEach((line, index) => {
            ctx.fillText(line, 150, 292 + (index * 24));
        });
    }

    ctx.fillStyle = '#0f2433';
    ctx.font = '500 24px JetBrains Mono';
    ctx.fillText(`Tx: ${shortHash(data.txHash || 'manual-entry', 14, 10)}`, 150, 360);

    const rows = [
        ['Tx Hash', data.txHash || 'manual-entry'],
        [senderLabel, data.sender],
        [receiverLabel, data.receiver],
        [amountLabel, `${data.amount} ${data.currency}`],
        [feeLabel, `${data.fee} ${data.feeCurrency || data.currency}`],
        ['Confirmations', `${data.confirmations}`],
        ['Timestamp', data.timestamp]
    ];

    if (data.explorerUrl) {
        rows.push(['Explorer', data.explorerUrl]);
    }

    let currentY = 438;
    rows.forEach(([label, value]) => {
        ctx.fillStyle = '#5b6874';
        ctx.font = '600 22px Space Grotesk';
        ctx.fillText(label, 150, currentY);

        ctx.fillStyle = '#122636';
        ctx.font = '500 22px JetBrains Mono';
        const maxLines = label === 'Tx Hash' || label === 'Explorer' ? 3 : 4;
        const lines = clampCanvasLines(ctx, wrapCanvasText(ctx, value, 860), 860, maxLines);
        lines.forEach((line, index) => {
            ctx.fillText(line, 330, currentY + (index * 30));
        });
        currentY += Math.max(74, (lines.length * 30) + 22);

        ctx.strokeStyle = '#dde8ee';
        ctx.beginPath();
        ctx.moveTo(150, currentY - 24);
        ctx.lineTo(1050, currentY - 24);
        ctx.stroke();
    });

    const qrValue = data.explorerUrl || (data.txHash ? `${data.chain}:${data.txHash}` : `${data.chain}:manual`);
    const qrDataUrl = await generateQrDataUrl(qrValue);
    const qrImage = new Image();
    await new Promise((resolve, reject) => {
        qrImage.onload = resolve;
        qrImage.onerror = reject;
        qrImage.src = qrDataUrl;
    });
    const qrTop = Math.min(Math.max(currentY + 24, 1090), 1400);
    ctx.drawImage(qrImage, 420, qrTop, 360, 360);

    ctx.fillStyle = '#5b6874';
    ctx.font = '500 22px Space Grotesk';
    ctx.fillText(data.explorerUrl ? 'Scan to open blockchain explorer' : 'Scan to reference transaction hash', 380, qrTop + 400);

    return canvas.toDataURL('image/png');
}

async function handleGenerateReceiptImage() {
    elements.generateReceiptBtn.classList.add('loading');
    elements.generateReceiptBtn.disabled = true;
    let shouldShowInterstitial = false;

    try {
        const receiptData = collectReceiptData();
        const imageDataUrl = await createReceiptImage(receiptData);
        state.receiptImageDataUrl = imageDataUrl;

        elements.receiptImagePreview.src = imageDataUrl;
        elements.receiptOutput.style.display = 'block';
        setFeedback(elements.receiptFeedback, 'Receipt image generated.');
        shouldShowInterstitial = true;
    } catch (error) {
        console.error('Generate receipt failed:', error);
        setFeedback(elements.receiptFeedback, error.message || 'Failed to generate receipt image.', true);
        showAlert(error.message || 'Failed to generate receipt image.');
    } finally {
        elements.generateReceiptBtn.classList.remove('loading');
        elements.generateReceiptBtn.disabled = false;
        if (shouldShowInterstitial) {
            await showRichAdsInterstitial();
        }
    }
}

function handleDownloadReceiptImage() {
    if (!state.receiptImageDataUrl) {
        showAlert('Generate a receipt image first.');
        return;
    }
    downloadDataUrl(state.receiptImageDataUrl, `on-chain-receipt-${Date.now()}.png`);
    setFeedback(elements.receiptFeedback, 'Receipt downloaded.');
}

async function handleSendReceiptToChat() {
    if (!state.receiptImageDataUrl) {
        showAlert('Generate a receipt image first.');
        return;
    }

    elements.sendReceiptBtn.classList.add('loading');
    elements.sendReceiptBtn.disabled = true;
    try {
        const receiptMessageParts = [];
        if (state.receiptFetchedData?.txHash) {
            receiptMessageParts.push(`Tx hash: ${state.receiptFetchedData.txHash}`);
        }
        if (state.receiptFetchedData?.explorerUrl) {
            receiptMessageParts.push(`Explorer: ${state.receiptFetchedData.explorerUrl}`);
        }

        await sendImageToChat(
            state.receiptImageDataUrl,
            `on-chain-receipt-${Date.now()}.png`,
            {
                message: receiptMessageParts.join(' | ')
            }
        );
        setFeedback(elements.receiptFeedback, 'Receipt sent with tx hash/explorer message.');
    } catch (error) {
        console.error('Failed to send receipt:', error);
        setFeedback(elements.receiptFeedback, error.message || 'Failed to send receipt.', true);
        showAlert(error.message || 'Failed to send receipt image.');
    } finally {
        elements.sendReceiptBtn.classList.remove('loading');
        elements.sendReceiptBtn.disabled = false;
    }
}

async function handlePurchasePro() {
    if (!tg || !tg.openInvoice) {
        showAlert('Payment feature is unavailable in this environment.');
        return;
    }

    if (state.isPro) {
        showAlert('No Ads mode is already active.');
        return;
    }

    elements.buyProBtn.disabled = true;
    elements.buyProBtn.innerHTML = 'Creating invoice...';

    try {
        const userId = tg.initDataUnsafe?.user?.id || null;
        const response = await fetch('/api/create-pro-invoice', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId })
        });
        const data = await response.json();

        if (!response.ok || !data.success) {
            throw new Error(data.message || 'Failed to create Pro invoice.');
        }

        tg.openInvoice(data.invoiceLink, async (status) => {
            if (status === 'paid') {
                startProPolling();
                try {
                    await syncUserStatus();
                    if (state.isPro) {
                        stopProPolling();
                        showAlert(MSG_PRO_SUCCESS);
                    } else {
                        showAlert(MSG_PAYMENT_PROCESSING);
                    }
                } catch (syncError) {
                    console.error('Immediate sync failed, polling continues:', syncError);
                    showAlert(MSG_PAYMENT_PROCESSING);
                }
            } else if (status === 'cancelled') {
                showAlert('Payment was cancelled.');
            } else if (status === 'failed') {
                showAlert('Payment failed. Please try again.');
            }
        });
    } catch (error) {
        console.error('Error creating Pro invoice:', error);
        showAlert(`Failed to create payment: ${error.message}`);
    } finally {
        elements.buyProBtn.disabled = false;
        restoreDefaultButtonHtml(elements.buyProBtn);
    }
}

function parseHexColor(value) {
    const raw = String(value || '').trim();
    if (!raw) return null;

    const normalized = raw.startsWith('#') ? raw.slice(1) : raw;
    const expanded = normalized.length === 3
        ? normalized.split('').map((part) => `${part}${part}`).join('')
        : normalized;

    if (!/^[0-9a-fA-F]{6}$/.test(expanded)) return null;

    return {
        r: parseInt(expanded.slice(0, 2), 16),
        g: parseInt(expanded.slice(2, 4), 16),
        b: parseInt(expanded.slice(4, 6), 16)
    };
}

function toHexColor(color) {
    const toHex = (value) => Math.max(0, Math.min(255, Math.round(value))).toString(16).padStart(2, '0');
    return `#${toHex(color.r)}${toHex(color.g)}${toHex(color.b)}`;
}

function colorOrFallback(value, fallback) {
    const parsed = parseHexColor(value) || parseHexColor(fallback);
    return toHexColor(parsed);
}

function mixColor(colorA, colorB, ratioB) {
    const a = parseHexColor(colorA);
    const b = parseHexColor(colorB);
    if (!a || !b) return colorA;
    const ratio = Math.max(0, Math.min(1, ratioB));
    return toHexColor({
        r: a.r + ((b.r - a.r) * ratio),
        g: a.g + ((b.g - a.g) * ratio),
        b: a.b + ((b.b - a.b) * ratio)
    });
}

function colorLuminance(color) {
    const parsed = parseHexColor(color);
    if (!parsed) return 1;
    const normalize = (value) => {
        const channel = value / 255;
        return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
    };
    return (0.2126 * normalize(parsed.r)) + (0.7152 * normalize(parsed.g)) + (0.0722 * normalize(parsed.b));
}

function isDarkColor(color) {
    return colorLuminance(color) < 0.45;
}

function toRgba(color, alpha) {
    const parsed = parseHexColor(color);
    if (!parsed) return `rgba(0, 0, 0, ${alpha})`;
    return `rgba(${parsed.r}, ${parsed.g}, ${parsed.b}, ${alpha})`;
}

function applyTheme() {
    const theme = tg?.themeParams || {};
    const safeText = colorOrFallback(theme.text_color, '#0d1a24');
    const safeBg = colorOrFallback(theme.bg_color, '#f3f6f8');
    const safeSecondary = colorOrFallback(theme.secondary_bg_color, '#f6fbfc');
    const safeButton = colorOrFallback(theme.button_color, '#0b7a75');

    const darkTheme = isDarkColor(safeBg);
    const surface = darkTheme ? mixColor(safeBg, '#ffffff', 0.08) : mixColor(safeBg, '#ffffff', 0.9);
    const line = darkTheme ? mixColor(safeBg, safeText, 0.44) : mixColor(safeBg, safeText, 0.18);
    const muted = darkTheme ? mixColor(safeText, safeBg, 0.4) : mixColor(safeText, safeBg, 0.62);
    const tabBg = darkTheme ? mixColor(surface, safeBg, 0.45) : mixColor(surface, safeBg, 0.24);
    const tabText = darkTheme ? mixColor(safeText, safeBg, 0.18) : mixColor(safeText, safeBg, 0.36);
    const resultBg = darkTheme ? mixColor(surface, safeBg, 0.34) : mixColor(safeSecondary, '#ffffff', 0.45);
    const resultBorder = darkTheme ? mixColor(line, safeText, 0.26) : mixColor(line, safeBg, 0.2);
    const chipBg = darkTheme ? mixColor(surface, safeBg, 0.32) : mixColor(safeButton, '#ffffff', 0.9);
    const chipBorder = darkTheme ? mixColor(line, safeText, 0.42) : mixColor(safeButton, safeBg, 0.35);
    const codeBg = darkTheme ? mixColor(surface, '#000000', 0.18) : '#ffffff';
    const codeText = darkTheme ? mixColor(safeText, '#ffffff', 0.08) : '#122636';
    const bgAlt = darkTheme ? mixColor(safeBg, '#000000', 0.22) : mixColor(safeBg, '#dce7ff', 0.35);
    const bgGlow = darkTheme ? mixColor(safeButton, safeBg, 0.74) : mixColor(safeButton, '#ffffff', 0.82);

    document.documentElement.style.setProperty('--text', safeText);
    document.documentElement.style.setProperty('--bg', safeBg);
    document.documentElement.style.setProperty('--bg-alt', bgAlt);
    document.documentElement.style.setProperty('--bg-glow', bgGlow);
    document.documentElement.style.setProperty('--surface', surface);
    document.documentElement.style.setProperty('--surface-soft', safeSecondary);
    document.documentElement.style.setProperty('--hero-bg-start', toRgba(surface, darkTheme ? 0.96 : 0.98));
    document.documentElement.style.setProperty('--hero-bg-end', toRgba(safeSecondary, darkTheme ? 0.92 : 0.92));
    document.documentElement.style.setProperty('--muted', muted);
    document.documentElement.style.setProperty('--line', line);
    document.documentElement.style.setProperty('--result-bg', resultBg);
    document.documentElement.style.setProperty('--result-border', resultBorder);
    document.documentElement.style.setProperty('--tab-bg', tabBg);
    document.documentElement.style.setProperty('--tab-text', tabText);
    document.documentElement.style.setProperty('--chip-bg', chipBg);
    document.documentElement.style.setProperty('--chip-border', chipBorder);
    document.documentElement.style.setProperty('--code-bg', codeBg);
    document.documentElement.style.setProperty('--code-text', codeText);
    document.documentElement.style.setProperty('--brand', safeButton);
    document.documentElement.style.setProperty('--shadow', darkTheme ? '0 18px 34px rgba(0, 0, 0, 0.44)' : '0 10px 30px rgba(13, 26, 36, 0.08)');

    document.body.classList.toggle('theme-dark', darkTheme);
}

function setupEventListeners() {
    elements.payNetworkBtc.addEventListener('click', () => switchPaymentNetwork('bitcoin'));
    elements.payNetworkEth.addEventListener('click', () => switchPaymentNetwork('ethereum'));
    elements.payNetworkUsdt.addEventListener('click', () => switchPaymentNetwork('usdt'));
    elements.payNetworkSol.addEventListener('click', () => switchPaymentNetwork('solana'));
    elements.ethRequestType.addEventListener('change', toggleEthTokenFields);
    elements.generatePaymentUriBtn.addEventListener('click', handleGeneratePaymentUri);
    elements.copyPaymentUriBtn.addEventListener('click', handleCopyPaymentUri);
    elements.downloadPaymentQrBtn.addEventListener('click', handleDownloadPaymentImage);
    elements.sendPaymentQrBtn.addEventListener('click', handleSendPaymentToChat);

    elements.receiptChain.addEventListener('change', () => setReceiptDefaultsForChain(elements.receiptChain.value));
    elements.fetchTxBtn.addEventListener('click', fetchTransactionDetails);
    elements.generateReceiptBtn.addEventListener('click', handleGenerateReceiptImage);
    elements.downloadReceiptBtn.addEventListener('click', handleDownloadReceiptImage);
    elements.sendReceiptBtn.addEventListener('click', handleSendReceiptToChat);

    elements.modeString.addEventListener('click', () => switchMode('string'));
    elements.modeNumber.addEventListener('click', () => switchMode('number'));
    elements.lengthSlider.addEventListener('input', syncLengthFromSlider);
    elements.stringLength.addEventListener('input', syncLengthFromInput);
    elements.lengthDecrease.addEventListener('click', () => adjustLength(-1));
    elements.lengthIncrease.addEventListener('click', () => adjustLength(1));
    elements.generateBtn.addEventListener('click', handleGenerate);
    elements.copyBtn.addEventListener('click', handleCopyLegacyResult);
    elements.resetBtn.addEventListener('click', handleResetLegacy);
    elements.buyProBtn.addEventListener('click', handlePurchasePro);

    [elements.optUppercase, elements.optLowercase, elements.optNumbers, elements.optSpecial].forEach((checkbox) => {
        checkbox.addEventListener('change', validateCheckboxes);
    });
}

async function initApp() {
    configureMonetizationButtons();
    if (elements.usdtTokenAddress && !elements.usdtTokenAddress.value.trim()) {
        elements.usdtTokenAddress.value = USDT_MAINNET_CONTRACT;
    }

    switchPaymentNetwork('bitcoin');
    toggleEthTokenFields();
    setReceiptDefaultsForChain(elements.receiptChain.value);
    applyTheme();
    if (tg?.onEvent) {
        tg.onEvent('themeChanged', applyTheme);
    }
    await syncUserStatus();
    setupEventListeners();
}

if (tg) {
    initApp();
}
